import * as React from 'react';
import { useVariableValue } from '../../types/dvcVariableTypes';

/**
 * Applies a data attribute to the document element so we can apply feature flag styles in CSS
 */
const M1FeatureFlagSync = () => {
    const applyAppUnityReleaseM1Changes = useVariableValue('project_sealeo_ui', false);

    React.useEffect(() => {
        if (applyAppUnityReleaseM1Changes) {
            document.documentElement.dataset.sealeo = 'true';
        } else {
            delete document.documentElement.dataset.sealeo;
        }
    }, [applyAppUnityReleaseM1Changes]);

    React.useEffect(
        () => () => {
            delete document.documentElement.dataset.sealeo;
        },
        []
    );

    return null;
};

export default M1FeatureFlagSync;
